import React from 'react'
import { DocumentListCard } from '@yes.technology/react-toolkit'
import { useSectionLayout } from './hooks/useSectionLayout'
import type { SectionViewProps } from './SectionView.types'

const SectionView = ({ children }: SectionViewProps) => {
  const { dividerTitle, isVisible, DividerComponent } = useSectionLayout()

  return (
    <DividerComponent
      title={dividerTitle}
      backgroundColor='#004099'
      isVisible={isVisible}
    >
      <DocumentListCard style={{ padding: 8 }}>{children}</DocumentListCard>
    </DividerComponent>
  )
}

export default SectionView
